// questo è il controller della modale 
(function () {
    'use strict';
    var controllerId = 'incontroAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'contratti', 'tipoIncontri', incontroAdd]);

    // Le modali lavorano con $scope e non con vm
    function incontroAdd($scope, $uibModalInstance, $filter, datacontext, common, contratti, tipoIncontri) {
        $scope.contrattoIncontro = {};
        $scope.contratti = contratti;
        $scope.tipoIncontri = tipoIncontri;

        // gestione di Data Prevista
        if ($scope.contrattoIncontro.DataPrevista && $scope.contrattoIncontro.DataPrevista != null)
            $scope.contrattoIncontro.DataPrevista = new Date($scope.contrattoIncontro.DataPrevista);

        // gestione di Data Effettuato
        if ($scope.contrattoIncontro.DataEffettuato && $scope.contrattoIncontro.DataEffettuato != null)
            $scope.contrattoIncontro.DataEffettuato = new Date($scope.contrattoIncontro.DataEffettuato);

        //DatePicker (gestione del calendario)
        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = !$scope.opened;
            $scope.opened1 = false;
        };
        $scope.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = !$scope.opened1;
            $scope.opened = false;
        };
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.contrattoIncontro)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.contrattoIncontro_add(item).then(function (data) {
                if (!data) return null;
                return data;
            });
        }
    }
})();